<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2 v-if="!isAdminSecurite">Consulter ou modifier les données d'accidentologie
            soumises</h2>
        <h2 v-if="isAdminSecurite">Consulter les données d'accidentologie</h2>

        <b-col cols="10">
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-marches"
                                  :label=libelles.marche label-for="input-marches"
                                  v-if="isAdmin">
                        <AutocompleteCustom
                                id="input-marches"
                                :items="marcheIdsItems"
                                v-model="marcheId"
                                @search="onMarcheSearch"
                                :placeholder=libelles.selectionnerMarche
                                :clear=ligneId
                        >
                        </AutocompleteCustom>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group id="input-group-lignes"
                                  :label=libelles.ligne label-for="input-lignes"
                                  v-if="isAdmin">
                        <b-form-select
                                id="input-lignes"
                                v-model="ligneId"
                                :options="lignes"
                                required>
                            <template v-slot:first>
                                <b-form-select-option :value="null">
                                    {{libelles.selectionnerLigne}}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="1" offset="3">
                    <b-button v-if="marcheId || ligneId" type="button" variant="success" @click="exporter">
                        {{libelles.exporter}}
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-date-debut" label-for="input-date-debut">
                        <template v-slot:label>
                            <label-custom
                                    :label=libelles.dateDebut>
                            </label-custom>
                        </template>
                        <vue-monthly-picker
                                id="input-date-debut"
                                dateFormat="MM/YYYY"
                                :monthLabels="monthLabels"
                                v-model="dateDebut"
                                @selected="search()"
                        >
                        </vue-monthly-picker>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group id="input-group-date-fin" label-for="input-date-fin">
                        <template v-slot:label>
                            <label-custom
                                    :label=libelles.dateFin>
                            </label-custom>
                        </template>
                        <vue-monthly-picker
                                id="input-date-fin"
                                dateFormat="MM/YYYY"
                                :monthLabels="monthLabels"
                                v-model="dateFin"
                                @selected="search()"
                        >
                        </vue-monthly-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-statuts"
                                  :label=libelles.statut label-for="input-statuts">
                        <b-form-select
                                id="input-statuts"
                                v-model="statuts"
                                @change="search">
                            <b-form-select-option :value="['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION']">
                                Valides et en attente
                            </b-form-select-option>
                            <b-form-select-option :value="['SUPPRIMEE', 'ARCHIVEE', 'REFUSE']">
                                Archivés
                            </b-form-select-option>
                            <b-form-select-option
                                    :value="['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION', 'SUPPRIMEE', 'ARCHIVEE', 'REFUSE']">
                                Tous
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

        </b-col>

        <div v-if="securiteChantiersResult">
            <div class="overflow-auto">
                <b-row class="align-content-center">
                    <b-col cols="2">
                        <b-form-select
                                v-model="pageSize"
                                :options="pageSizes"
                                @change="search()"
                        ></b-form-select>
                    </b-col>
                    <b-col cols="4" offset="1">
                        <b-pagination
                                v-model="pageIndex"
                                :total-rows="securiteChantiersResult.totalElements"
                                :per-page="pageSize"
                                :limit="10"
                                align="center"
                                @input="search()"
                        ></b-pagination>
                    </b-col>
                </b-row>

                <b-table striped hover
                         :per-page="pageSize"
                         :no-local-sorting="true"
                         @sort-changed="sort"
                         :items="securiteChantiersTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{pageSize * (pageIndex - 1) + (row.index + 1)}}
                        </div>
                    </template>
                    <template v-slot:cell(edit)="row">
                        <b-button size="sm" @click="consulterSecuriteChantiers(row.item.id)"
                                  v-if="row.item.statut !== 'VALIDE' || isRead">
                            <Icon icon="book-open" size="1x"></Icon>
                        </b-button>
                        <b-button size="sm" @click="consulterSecuriteChantiers(row.item.id)"
                                  v-if="row.item.statut === 'VALIDE' && (!row.item.jourSoumissionPassed || isAdminSecurite) && !isRead">
                            <Icon icon="edit" size="1x"></Icon>
                        </b-button>
                        <b-button size="sm"
                                  v-if="row.item.statut === 'VALIDE' && row.item.jourSoumissionPassed && !isAdminSecurite && !isRead"
                                  v-b-modal="'modal-edit' + row.item.id">
                            <Icon icon="edit" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-edit' + row.item.id"
                                title="Modification de données d'accidentologie"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="consulterSecuriteChantiers(row.item.id)">
                            <p>{{libelles.messageHorsPeriodeSoumission}}</p>
                        </b-modal>
                    </template>
                    <template v-slot:cell(delete)="row">
                        <b-button size="sm" v-b-modal="'modal-delete' + row.item.id"
                                  v-if="row.item.statut !== 'ATTENTE_SUPPRESSION' && row.item.statut !== 'SUPPRIMEE' && row.item.statut !== 'ARCHIVEE'">
                            <Icon icon="trash" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-delete' + row.item.id"
                                title="Suppression de données d'accidentologie"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="supprimerSecuriteChantiers(row.item)">
                            <p>{{libelles.confirmationSuppression}}</p>
                            <p v-if="row.item.statut === 'VALIDE'">
                                La suppression de ces données d'accidentologie entrainera la suppression des
                                modifications en attente associées.
                            </p>
                            <p v-if="row.item.jourSoumissionPassed && !isAdminSecurite && row.item.statut === 'VALIDE'">
                                {{libelles.messageHorsPeriodeSoumission}}
                            </p>
                        </b-modal>
                    </template>
                </b-table>
            </div>
        </div>

    </div>
</template>

<script>

  import MarcheSecuriteChantiersStore from "../../stores/MarcheSecuriteChantiersStore";
  import AlertStore from "../../stores/AlertStore";
  import MarcheStore from "../../stores/MarcheStore";
  import LigneStore from "../../stores/LigneStore";
  import SessionStore from '@/stores/SessionStore'
  import hasPermission from "../../filters/hasPermission";
  import {EventBus} from '@/event-bus'
  import {StatutEnum} from "../../constants/enums";
  import moment from 'moment';
  import MarcheSecuriteChantiersDto from "../../dtos/MarcheSecuriteChantiersDto";
  import {libelles} from '../../constants/libelles';
  import FileUtil from "../../utils/fileUtil";
  import VueMonthlyPicker from "vue-monthly-picker";
  import {mois} from "../../constants/enums";
  import LabelCustom from "../../components/LabelCustom";
  import {momentToDate} from "../../utils/dateUtil";
  import AutocompleteCustom from "../../components/AutocompleteCustom";

  export default {
    components: {
      VueMonthlyPicker,
      LabelCustom,
      AutocompleteCustom
    },
    data() {
      return {
        sessionStoreState: SessionStore.state,
        marcheId: null,
        ligneId: null,
        marches: [],
        lignes: [],
        statuts: ['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION'],
        securiteChantiersResult: null,
        pageSize: null,
        pageSizes: [10, 25, 50, 100],
        pageIndex: null,
        sortOptions: null,
        libelles: libelles,
        dateDebut: null,
        dateFin: null,
        monthLabels: mois,
        marcheIdsItems: [],
      }
    },
    computed: {
      isAdminSecurite() {
        return hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR']);
      },
      isAdmin() {
        return this.isAdminSecurite && !this.sessionStoreState.marches.length;
      },
      isRead() {
        return hasPermission(['CORRESPONDANT_SECURITE_LECTURE'])
      },
      fields() {
        const fields = [
          {label: '', key: 'num', sortable: false},
          {label: 'Date de dernière modification', key: 'modifiedDate', sortable: true},
          {label: 'Données pour le mois', key: 'date', sortable: true},
          {label: 'Statut', key: 'statutLabel', sortable: false},
          {label: 'Consulter / Modifier', key: 'edit', sortable: false},
          {label: 'Supprimer', key: 'delete', sortable: false}
        ];
        if (this.isAdmin) {
          fields.splice(1, 0, {label: 'Marché', key: 'marche', sortable: true})
        }
        if (this.isRead) {
          fields.splice(fields.length - 1, 1)
        }
        return fields;
      },
      securiteChantiersTable: function () {
        return this.securiteChantiersResult.content.map(securiteChantiers => {
          return {
            id: securiteChantiers.id,
            date: moment(securiteChantiers.date).format('MM/YYYY'),
            marche: `${securiteChantiers.marche.reference} (${securiteChantiers.marche.libelleCourt})`,
            statut: securiteChantiers.statut,
            statutLabel: StatutEnum[securiteChantiers.statut],
            jourSoumissionPassed: securiteChantiers.jourSoumissionPassed,
            modifiedDate: new Date(securiteChantiers.modifiedDate).toLocaleDateString(),
          }
        });
      }
    },
    watch: {
      marcheId(newMarcheId) {
        this.onMarcheSearch(newMarcheId, true);
        this.search();
      },
      ligneId(newLigneId) {
        if (newLigneId) {
          this.marcheId = null;
        }
        this.onMarcheSearch();
        this.search();
      },
    },
    mounted() {
      this.initPagination();
      if (this.isAdmin) {
        MarcheStore.getAll().then(marches => {
          this.marches = marches.map(marche => {
            return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
          });
          this.marcheIdsItems = this.marches;
        });
        LigneStore.getAll().then(
            response => this.lignes = response.map(value => {
              return {text: value.libelleLong, value: value.id};
            })
        );
        this.search();
      } else {
        this.marcheId = this.sessionStoreState.marche.id;
        EventBus.$on('NavBar-marcheChange', () => {
          this.marcheId = this.sessionStoreState.marche.id;
        });
      }
    },
    beforeDestroy() {
      if (!this.isAdmin) {
        EventBus.$off('NavBar-marcheChange');
      }
    },
    methods: {
      initPagination() {
        this.pageSize = 10;
        this.pageIndex = 1;
        const sortBy = !this.isAdmin ? 'date' : 'marche';
        this.sortOptions = [{sortBy: sortBy, sortDirection: 'asc'}];
      },
      sort(sort) {
        this.sortOptions = [{sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc'}];
        this.search();
      },
      consulterSecuriteChantiers(id) {
        this.$router.push("/marche-securite-chantiers/" + id);
      },
      supprimerSecuriteChantiers(effectifInfos) {
        MarcheSecuriteChantiersStore.delete(effectifInfos).then(() => {
          this.search();
        });
      },
      search() {
        const marcheSecurite = this.getSearchMarcheSecurite();
        MarcheSecuriteChantiersStore.search(marcheSecurite, this.pageIndex - 1, this.pageSize, this.sortOptions).then(
            result => {
              this.securiteChantiersResult = result.data;
            },
            error => AlertStore.pushError(error.response.data.message)
        )

      },
      exporter() {
        if (this.marcheId || this.ligneId) {
          const marcheSecurite = this.getSearchMarcheSecurite();
          marcheSecurite.statut = ['VALIDE'];
          MarcheSecuriteChantiersStore.export(marcheSecurite).then(
              result => {
                FileUtil.downloadFile(result.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf8;');
              },
              error => AlertStore.pushError(error.response.data.message)
          )
        }
      },
      getSearchMarcheSecurite() {
        const marcheSecurite = new MarcheSecuriteChantiersDto();
        marcheSecurite.marche = this.marcheId;
        marcheSecurite.ligneId = this.ligneId;
        marcheSecurite.statut = this.statuts;
        marcheSecurite.dateDebut = this.dateDebut ? momentToDate(this.dateDebut) : null;
        marcheSecurite.dateFin = this.dateFin ? momentToDate(this.dateFin) : null;
        return marcheSecurite;
      },
      onMarcheSearch(marche, isId) {
        if (marche) {
          this.ligneId = null;
        }
        this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marches)
      }
    }
  }
</script>

